<h2 mat-dialog-title>AGGIUNGI NUOVO REPORTNET3</h2>
<mat-dialog-content>
    <p>Per aggiungere un nuovo Reportnet è necessario andare nella sezione Controlli, 
        selezionare il controllo specifico e cliccare sul pulsante + relativo al 
        parametro ricercato.</p>
</mat-dialog-content>
<mat-dialog-actions class="my-padding-dialog justify-content-end">
    <app-button label="Chiudi" [fullWidth]="false" (click)="closeModal()" raised></app-button>
</mat-dialog-actions>